module.exports = __webpack_public_path__ + "first-50_microprint.jpg?d4045372c00a3e0b7c747cb91e6df6ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50_microprint.jpg
// module id = 571
// module chunks = 0